module.exports = __webpack_public_path__ + "static/media/reprint_lsr_icon_disabled.bfcdae84.svg";